import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Beneficios from "./pages/Beneficios";
import Adesao from "./pages/Adesao";
import Contato from "./pages/Contato";
import MemberLogin from "./pages/MemberLogin";
import MemberDashboard from "./pages/MemberDashboard";
import Pagamento from "./pages/Pagamento";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Overview from "./pages/admin/Overview";
import Members from "./pages/admin/Members";
import Payments from "./pages/admin/Payments";
import Reports from "./pages/admin/Reports";

function Protected({ role, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined)
    return (
      <div className="min-h-[50vh] grid place-items-center text-neutral-500">Carregando…</div>
    );
  if (!user) {
    const to = role === "admin" ? "/admin/login" : "/entrar";
    return <Navigate to={to} state={{ from: loc.pathname }} replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppShell() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="/beneficios"
        element={
          <Layout>
            <Beneficios />
          </Layout>
        }
      />
      <Route
        path="/adesao"
        element={
          <Layout>
            <Adesao />
          </Layout>
        }
      />
      <Route
        path="/contato"
        element={
          <Layout>
            <Contato />
          </Layout>
        }
      />
      <Route
        path="/entrar"
        element={
          <Layout>
            <MemberLogin />
          </Layout>
        }
      />
      <Route
        path="/painel"
        element={
          <Layout>
            <Protected role="member">
              <MemberDashboard />
            </Protected>
          </Layout>
        }
      />
      <Route
        path="/pagamento"
        element={
          <Layout>
            <Protected role="member">
              <Pagamento />
            </Protected>
          </Layout>
        }
      />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <Protected role="admin">
            <AdminLayout />
          </Protected>
        }
      >
        <Route index element={<Overview />} />
        <Route path="associados" element={<Members />} />
        <Route path="mensalidades" element={<Payments />} />
        <Route path="relatorios" element={<Reports />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
